const auxilliary = (props) => props.children;

export default auxilliary;



// WEBPACK FOOTER //
// ./src/hoc/auxilliary.js